import i18n from "../../../i18n";
import { transformGreekToEnglish } from "../../../lib/helperFuncs";

export const mapOrganisationDetails = (omekaData: any) => {

  const suntomorgafiaForea = omekaData?.['organisations:organisationsAbbreviation']?.map((item: any) => item?.['@value']);
  const sutomografiaForeaAgglika = omekaData?.['organisations:organisationsEnAbbreviation']?.map((item: any) => item?.['@value']);
  const anagnoristikoForea = omekaData?.['organisations:orgIdentifierCountryId']?.map((item: any) => item?.['@value']);
  const foreasEmail = omekaData?.['organisations:organisationsEmail']?.map((item: any) => item?.['@value']);
  const foreasPhone = omekaData?.['organisations:organisationsTelephone']?.map((item: any) => item?.['@value']);
  const foreasWebsite = omekaData?.['organisations:organisationsWebsite']?.map((item: any) => item?.['@value']);
  const foreasCountry = omekaData?.['organisations:organisationsCountry']?.map((item: any) => item?.['@value']);
  const foreasTown = omekaData?.['organisations:organisationsCity']?.map((item: any) => item?.['@value']);
  const foreasAddress = omekaData?.['organisations:organisationsAddress']?.map((item: any) => item?.['@value']);
  const organisationsCollectionsDescription = omekaData?.['organisations:organisationsCollectionsDescription']?.map((item: any) => item?.['@value']);
  const organisationFullAddress = omekaData?.['organisations:orgIdentifierFullAddress']?.map((item: any) => i18n.language === 'el'
    ? item?.['@value']
    : transformGreekToEnglish(item?.['@value']));
  const comments = omekaData?.['organisations:orgIdentifierComments']?.map((item: any) => item?.['@value']);
  const comments_en = omekaData?.['organisations:orgIdentifierCommentsEn']?.map((item: any) => item?.['@value']);
  
  return {
    suntomorgafiaForea,
    sutomografiaForeaAgglika,
    anagnoristikoForea,
    foreasEmail,
    foreasPhone,
    foreasWebsite,
    foreasCountry,
    foreasTown,
    foreasAddress,
    organisationsCollectionsDescription,
    organisationFullAddress,
    comments,
    comments_en
  };
};

export const extractIdFromUrl = (url: string): number | null => {
  const parts = url.split('/');
  const number = parseInt(parts[parts.length - 1]);
  return isNaN(number)
    ? null
    : number;
};

export const collectionDetails = (data: any) => {
  return data.reverse['collections:collectionsRelateOrganisation'].data
    .filter((x: any) => x['o:is_public'] === true)
    .map((x: any) => {
      return {
        name: i18n.language === 'el'
          ? x['collections:collectionsTitle']?.map((item: any) => item?.['@value'])[0]
          : x['collections:collectionsEnTitle']?.map((item: any) => item?.['@value'])[0],
        value: i18n.language === 'el'
          ? x['collections:collectionsDescription']?.map((item: any) => item?.['@value'])[0]
          : x['collections:collectionEnDescription']?.map((item: any) => item?.['@value'])[0],
        url: `/collections/details/${x['o:id']}` 
      };
    });
};

export const documentDetails = (data: any) => {
  return data.reverse['documents:documentsRelationCollection'].data
    // .filter((x: any) => x['o:is_public'] === true)
    .map((x: any) => {      
      return {
        id: extractIdFromUrl(x['@id']),
        name: x['o:title'],
        value: '',
        url: `/search-documents/details/${extractIdFromUrl(x['@id'])}` 
      };
    });
};

export const basicDetailsOrganisation = 
[
  [ 'suntomorgafiaForea',
    'anagnoristikoForea'
  ],
  ['sutomografiaForeaAgglika']
];

export const contactDetailsOrganisation = [
  [ 'foreasPhone','foreasEmail','foreasWebsite'],
  ['organisationFullAddress','foreasCountry']
];
